<template>
  <!-- Barre des actions de masse. Elle ne porte plus la case « Tout sélectionner » :
       celle-ci a rejoint la première colonne du tableau, là où l'utilisateur la cherche.
       La barre n'a donc plus de raison d'exister tant que rien n'est sélectionné. -->
  <v-row v-if="hasSelection" class="ma-0 selection-row align-center" no-gutters>
    <v-col cols="auto" class="d-flex align-center">
      <span class="selection-count">{{ countLabel }}</span>
    </v-col>
    <v-col class="d-flex align-center ms-4">
      <!-- Point d'accroche des actions de masse (DPAE, signature, validation, règlement). -->
      <slot name="actions"></slot>
    </v-col>
  </v-row>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'SectionContratSelectionBar',
    props: {
      selectedCount: {
        type: Number,
        required: true,
      },
    },
    computed: {
      hasSelection (): boolean {
        return this.selectedCount > 0;
      },
      countLabel (): string {
        if (this.selectedCount > 1) {
          return `${this.selectedCount} fiches sélectionnées`;
        }
        return `${this.selectedCount} fiche sélectionnée`;
      },
    },
  });
</script>

<style scoped>
  .selection-row {
    padding-bottom: 15px;
  }

  .selection-count {
    font-size: 14px;
    font-weight: 600;
    color: #135253;
  }
</style>
